<template>
  <div class="wrapper">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              {{ $t('se211.title') }}
            </div>
          </section>
          <section class="section02">
            <div class="object01"></div>
            <div class="object02">
              {{ $t('se211.push') }}
            </div>
            <!-- ON 일때(Class) : active -->
            <div class="object03" :class="alarmReceptInfo.pushReceptYn ? 'active' : ''" @click="pushToggle">
              <div class="switch">
                <div class="item01"></div>
              </div>
            </div>
            <div class="object04"></div>
            <div class="object05">
              {{ $t('se211.sms') }}
            </div>
            <!-- ON 일때(Class) : active -->
            <div class="object06" :class="alarmReceptInfo.smsReceptYn ? 'active' : ''" @click="smsToggle">
              <div class="switch">
                <div class="item01"></div>
              </div>
            </div>
            <div class="object07"></div>
            <div class="object08">
              {{ $t('se211.email') }}
            </div>
            <!-- ON 일때(Class) : active -->
            <div class="object09" :class="alarmReceptInfo.emailReceptYn ? 'active' : ''" @click="emailToggle">
              <div class="switch">
                <div class="item01"></div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'

import {settingService, userService} from '../../router'

export default {
  name: 'SE211',
  data () {
    return {
      alarmReceptInfo: {
        pushReceptYn: false,
        smsReceptYn: false,
        emailReceptYn: false
      }
    }
  },
  created: function () {
    userService.getAll().then(response => {
      this.userInfo = response.data
    })
  },
  mounted: function () {
    this.setData()
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  methods: {
    setData: function () {
      settingService.getAlarmReceptInfo().then(response => {
        this.alarmReceptInfo = response.data.alarmReceptInfo
      }).catch(error => {
        console.log('getAlarmReceptInfo.err.===>', error)
      })
    },
    saveData: function () {
      settingService.setAlarmReceptInfo(this.alarmReceptInfo).then(response => {
        if (response.statusCode !== 200) {
          alert(response.message)
        }
      }).catch(error => {
        console.log('setAlarmReceptInfo.err.===>', error)
      })
    },
    pushToggle: function () {
      this.alarmReceptInfo.pushReceptYn = !this.alarmReceptInfo.pushReceptYn
      this.saveData()
    },
    smsToggle: function () {
      this.alarmReceptInfo.smsReceptYn = !this.alarmReceptInfo.smsReceptYn
      this.saveData()
    },
    emailToggle: function () {
      this.alarmReceptInfo.emailReceptYn = !this.alarmReceptInfo.emailReceptYn
      this.saveData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/setting/SE211.vue